<template>
  <div>
    <b-row>
      <b-col
        lg="4"
        md="4"
      >
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 478 144"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M21.744 143.5L1 128V8.5H426.175L443.315 0.5H477.442V8.5V128L456.698 143.5H21.744Z"
            stroke="#00B058"
          />
          <path
            d="M433.947 0H439.3L424.578 7H419.225L433.947 0Z"
            fill="#00B058"
          />
          <path
            d="M424.578 0H429.932L415.21 7H409.857L424.578 0Z"
            fill="#00B058"
          />
          <path
            d="M415.21 0H420.563L405.842 7H400.488L415.21 0Z"
            fill="#00B058"
          />
          <path
            d="M405.842 0H411.195L396.474 7H391.12L405.842 0Z"
            fill="#00B058"
          />
          <path
            d="M396.474 0H401.827L387.105 7H381.752L396.474 0Z"
            fill="#00B058"
          />
          <path
            d="M387.105 0H392.459L377.737 7H372.384L387.105 0Z"
            fill="#00B058"
          />
          <foreignObject
            width="100%"
            height="100%"
            x="25"
            y="25"
          >
            <div>
              <b-img
                height="35"
                src="@/assets/images/icons/Lighting.png"
              />
            </div>
          </foreignObject>
          <foreignObject
            width="100%"
            height="100%"
            x="70"
            y="30"
          >
            <div>
              <span style="font-size:20px; font-weight: 600;">จำนวนโคมทั้งหมด</span>
            </div>
          </foreignObject>
          <foreignObject
            width="100%"
            height="100%"
            x="420"
            y="30"
          >
            <div>
              <feather-icon
                v-b-modal="'Lora'"
                style="margin-bottom: 5px;cursor: pointer; color:rgb(148, 240, 148)"
                size="25"
                icon="WifiIcon"
                @click="$refs.refLora.getTableLoraWanDetail()"
              />
            </div>
          </foreignObject>
          <foreignObject
            x="200"
            y="70"
            width="100%"
            height="100%"
            color="#ffffff"
          >
            <span style="text-align:left; font-weight: 700; font-size:40px">
              {{ total }}
            </span>
            <span
              style="text-align:center; font-weight: 600; font-size:20px"
            >
              โคม
            </span>
          </foreignObject>
        </svg>
      </b-col>
      <!-- ---------------total location----------- -->
      <b-col
        lg="4"
        md="4"
      >
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 478 144"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M21.744 143.5L1 128V8.5H426.175L443.315 0.5H477.442V8.5V128L456.698 143.5H21.744Z"
            stroke="#00B058"
          />
          <path
            d="M433.947 0H439.3L424.578 7H419.225L433.947 0Z"
            fill="#00B058"
          />
          <path
            d="M424.578 0H429.932L415.21 7H409.857L424.578 0Z"
            fill="#00B058"
          />
          <path
            d="M415.21 0H420.563L405.842 7H400.488L415.21 0Z"
            fill="#00B058"
          />
          <path
            d="M405.842 0H411.195L396.474 7H391.12L405.842 0Z"
            fill="#00B058"
          />
          <path
            d="M396.474 0H401.827L387.105 7H381.752L396.474 0Z"
            fill="#00B058"
          />
          <path
            d="M387.105 0H392.459L377.737 7H372.384L387.105 0Z"
            fill="#00B058"
          />
          <foreignObject
            width="100%"
            height="100%"
            x="25"
            y="25"
          >
            <div>
              <b-img
                height="35"
                src="@/assets/images/icons/Online.svg"
              />
            </div>
          </foreignObject>
          <foreignObject
            width="100%"
            height="100%"
            x="70"
            y="30"
          >
            <div>
              <span style="font-size:20px; font-weight: 600; margin-left: 5px;">ใช้งานได้</span>
            </div>
          </foreignObject>
          <foreignObject
            x="200"
            y="70"
            width="100%"
            height="100%"
            color="#ffffff"
          >
            <span style="text-align:left; font-weight: 700; font-size:40px">
              {{ work }}
            </span>
            <span
              style="text-align:center; font-weight: 600; font-size:20px"
            >
              โคม
            </span>
          </foreignObject>
        </svg>
      </b-col>
      <b-col
        lg="4"
        md="4"
      >
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 478 144"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M21.744 143.5L1 128V8.5H426.175L443.315 0.5H477.442V8.5V128L456.698 143.5H21.744Z"
            stroke="#00B058"
          />
          <path
            d="M433.947 0H439.3L424.578 7H419.225L433.947 0Z"
            fill="#00B058"
          />
          <path
            d="M424.578 0H429.932L415.21 7H409.857L424.578 0Z"
            fill="#00B058"
          />
          <path
            d="M415.21 0H420.563L405.842 7H400.488L415.21 0Z"
            fill="#00B058"
          />
          <path
            d="M405.842 0H411.195L396.474 7H391.12L405.842 0Z"
            fill="#00B058"
          />
          <path
            d="M396.474 0H401.827L387.105 7H381.752L396.474 0Z"
            fill="#00B058"
          />
          <path
            d="M387.105 0H392.459L377.737 7H372.384L387.105 0Z"
            fill="#00B058"
          />
          <foreignObject
            width="100%"
            height="100%"
            x="25"
            y="25"
          >
            <div>
              <b-img
                height="35"
                src="@/assets/images/icons/Offline.svg"
              />
            </div>
          </foreignObject>
          <foreignObject
            width="100%"
            height="100%"
            x="70"
            y="30"
          >
            <div>
              <span style="font-size:20px; font-weight: 600; margin-left: 5px;">ใช้งานไม่ได้</span>
            </div>
          </foreignObject>
          <foreignObject
            x="200"
            y="70"
            width="100%"
            height="100%"
            color="#ffffff"
          >
            <span style="text-align:left; font-weight: 700; font-size:40px">
              {{ fail }}
            </span>
            <span
              style="text-align:center; font-weight: 600; font-size:20px"
            >
              โคม
            </span>
          </foreignObject>
        </svg>
      </b-col>
    </b-row>
    <modalLora
      ref="refLora"
    />
  </div>
</template>

<script>
import {
  BRow, BCol, BImg,
} from 'bootstrap-vue'
import axios from '@axios'
import Ripple from 'vue-ripple-directive'
import modalLora from './modalLora.vue'

export default {
  directives: {
    Ripple,
  },
  components: {
    BRow,
    BCol,
    BImg,
    modalLora,
  },
  data() {
    return {
      total: '',
      work: '',
      fail: '',
      totalLocation: '',
      totalWayID: '',
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  created() {
    this.getStatusSEM()
  },
  mounted() {
    this.interval = setInterval(() => {
      this.getStatusSEM()
    }, 300000)
  },
  methods: {
    getStatusSEM() {
      axios
        .post('/getStatusSEM', { wid: this.$route.query.wid })
        .then(response => {
          this.work = response.data[0].work
          this.fail = response.data[0].fail
          this.total = response.data[0].available
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
}
</script>

<style>
</style>
